import { StoryblokComponent } from '@storyblok/react';
import { MouseEventHandler } from 'react';

import { Button } from '../../../components/Button/Button';
import { patchedStoryblokEditable } from '../../../utils/patchedStoryblokEditable';
import { useFormBuilderContext } from '../hooks/useFormBuilderContext';
import { FormBuilderTypographyButtonWrapper } from './FormBuilderButton.styles';
import { FormBuilderButtonProps } from './FormBuilderButton.types';

export const FormBuilderButton = (props: FormBuilderButtonProps) => {
  const { blok } = props;
  const { clickActions, marginTop, marginBottom, fullWidth } = blok;

  const { setKeyValue } = useFormBuilderContext();

  const button = blok.button.length ? blok.button[0] : null;

  const handleButtonClick: MouseEventHandler = () => {
    clickActions.map((clickAction) => {
      if (clickAction.action === 'setKeyValue') {
        setKeyValue(clickAction.key, clickAction.value);
      }
    });
  };

  if (!button) {
    return null;
  }

  if (button.component === 'typography') {
    return (
      <FormBuilderTypographyButtonWrapper
        {...patchedStoryblokEditable(blok)}
        onClick={handleButtonClick}
        marginTop={marginTop}
        marginBottom={marginBottom}
        fullWidth={fullWidth}
      >
        <StoryblokComponent blok={button} />
      </FormBuilderTypographyButtonWrapper>
    );
  }

  if (button.component === 'button') {
    return (
      <Button
        {...patchedStoryblokEditable(blok)}
        onClickHandler={handleButtonClick}
        text={button.buttonText}
        variant={button.buttonVariant}
        url={button.buttonUrl}
        type="button"
        fullWidth={fullWidth}
        shrink
      />
    );
  }

  if (button.component === 'cta') {
    return (
      <FormBuilderTypographyButtonWrapper
        {...patchedStoryblokEditable(blok)}
        onClick={handleButtonClick}
        marginTop={marginTop}
        marginBottom={marginBottom}
        fullWidth={fullWidth}
        className="FormBuilderButton_CTA_Wrapper"
      >
        <StoryblokComponent blok={button} />
      </FormBuilderTypographyButtonWrapper>
    );
  }

  return null;
};
